import type { FaireProductEntity } from "../../entity_types/product";

export const p_nvymaseqg2: FaireProductEntity = {
  token: "p_nvymaseqg2",
  type: "product",
  name: "Absolutely Stunning One-Shoulder Halter Formal Midi Dress",
  brandToken: "b_9rvhvqmmsv",
  brandName: "The Moment Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/6c3dc0ac3dc3429c7fe9d1d00e656c40300d32ed40a5540f6b4fda2d78b7d69b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a4d044dfe0c2a9f05d6ab8f46e26c9d71c0a3667bba2151dcf4ff5c88ea687a.jpeg",
    "https://cdn.faire.com/fastly/4712e718058acafa3ba73fe29e1941abf961efbad6d8f5b8d88cadb55529b7d5.jpeg",
    "https://cdn.faire.com/fastly/396afc1301c823cee761d27ac276cde82f33c08690b70896563e6e7b5cf31281.jpeg",
    "https://cdn.faire.com/fastly/93c2e111ef41aaa91c6f51e1ebee01d2bd7dc0b7934ceee3c9db7d1bfbf6dacd.jpeg",
    "https://cdn.faire.com/fastly/5fdd50c0ca5a3f5e02ddab7b436b8f771e455473e42fafa60a7d3ecb15603e75.jpeg",
    "https://cdn.faire.com/fastly/1582569c57c15f7ff247d52ed443c52cb466b71b1278c2d8adcf01bbe15fbb8c.jpeg",
    "https://cdn.faire.com/fastly/95dda76860c779d6bb004f7fab5df56137d7f994e4347e0138cd79fb24a1d04d.jpeg",
    "https://cdn.faire.com/fastly/d62e87de1a8bc8bac850a980868e0e4270cca264d3303cb7cbcd21947b1a10ac.jpeg",
    "https://cdn.faire.com/fastly/5c51d71a9e527bee0364a034cd17bccf5fd7de8639f5632fe29b68e45e386aa5.jpeg",
    "https://cdn.faire.com/fastly/60d38f253da610424dfb6e41ebc7eec9a912d7c6951f0edb3188edb726edadf2.jpeg",
    "https://cdn.faire.com/fastly/144af7d4083a65c1755b68114eab13d46c0faec17309a0103c694b4a13401e59.jpeg",
    "https://cdn.faire.com/fastly/6c8c3beea3035fdca64295c423ee51ac445be9f632ff668e91fe69b745e7e5e2.jpeg",
    "https://cdn.faire.com/fastly/97d172ea2faa762ab835ed64a1525efda92a0a35a7b3db6ccc97b8341e7142ef.jpeg",
    "https://cdn.faire.com/fastly/84274633344f09cc06632fbe2403c53e1e84ef237766483d90264d8fd5976cf9.jpeg",
    "https://cdn.faire.com/fastly/fcb669e597392059216f4bcac3f03e4e874c60051149a05d6f2113a1cdad0259.jpeg",
    "https://cdn.faire.com/fastly/c389997ce6bcba1976df30245a27c70b711ee4e9cc81c5f84e790a6de488ab03.jpeg",
    "https://cdn.faire.com/fastly/0037fac0889d099e8817568b654b91d69959f2740ff6bf73afd09e4f945e502f.jpeg",
    "https://cdn.faire.com/fastly/45fdd6819e4955f3ca3fb94db729690d8e2e330f199da5870d2229869fdebd4e.jpeg",
    "https://cdn.faire.com/fastly/7b1cedd8661ce92eb6b7799357b86d3a66d177c9f9c0f86e85fc963275787e65.jpeg",
    "https://cdn.faire.com/fastly/1aee4da1d3036b10d7e0593e3747b1542fe38a233431646f7b2bfdaa3a8d8807.jpeg",
    "https://cdn.faire.com/fastly/4f776ca41034d7d1d9f47d2c6f7f44bd898e1e811fd392b53f4c1d19803b9079.jpeg",
    "https://cdn.faire.com/fastly/03d3f2a732884aeb93df4e2b6561094e1b6171c2ae031eeee1c6da062f01ce70.jpeg",
    "https://cdn.faire.com/fastly/3fc2023ad24672616bad87a4b9ccf5d99e5f3482991c76cb15851761290fcfca.jpeg",
    "https://cdn.faire.com/fastly/facfb7cd7b82a310d3b3cac35ed1531b7909b95eb7531d29800e057a25e022d1.png",
  ],
  priceDollars: 20.9,
  description:
    "*FEATURES: Soft and Lightweight Woven Fabric/Halter Neckline/One-Shoulder/Sleeveless/High, Elastic Waisted/Fitted Bodice/Hidden Zipper/Formal Dress/Midi Dress\n*UNLINED.\n*COLOR: APRICOT/BURGUNDY/LIGHT GREEN/NAVY/CORAL/DARK GREEN/OLIVE/PEACOCK BLUE/ROSE PINK/BLACK\n*SIZE: S/M/L/XL\n*STYLE: 70616\n*Support individual sizes and individual pieces.\n*2-5 days processing time.\n*Made in China.\n*Due to the style differences, please check out the last image for the size chart of this style.",
  tags: [],
  msrpDollars: 41.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:36.488Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
